import { render, staticRenderFns } from "./CoshhLev.vue?vue&type=template&id=fda02ffe&scoped=true&"
import script from "./CoshhLev.vue?vue&type=script&lang=js&"
export * from "./CoshhLev.vue?vue&type=script&lang=js&"
import style0 from "./CoshhLev.vue?vue&type=style&index=0&id=fda02ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda02ffe",
  null
  
)

export default component.exports